import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/**
 * Smart landing page redirect
 * - If user is authenticated: redirect to dashboard
 * - If user is not authenticated: redirect to login
 * - While loading: show loading screen
 */
function LandingRedirect() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#1a1a1a',
        color: '#c9a962'
      }}>
        <div style={{ textAlign: 'center' }}>
          <h2>The Ascended</h2>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  // If authenticated, go to dashboard
  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  // If not authenticated, go to login
  return <Navigate to="/login" replace />;
}

export default LandingRedirect;
